import React, { Component } from "react";
import { Table, Card } from "antd";
import moment from "moment";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: "日期",
        dataIndex: "date",
        render: text => (
          <span>
            {text ? moment.unix(text / 1000).format("YYYY-MM-DD") : ""}
          </span>
        ),
      },
      {
        title: "收入",
        dataIndex: "payMoney",
      },
      {
        title: "收入类型",
        dataIndex: "type",
        render: (text, record) => <span>{record.typeName}</span>,
      },
      {
        title: "备注",
        dataIndex: "remark",
      },
      {
        title: "对方户名",
        dataIndex: "accountName",
      },
    ];
  };

  render() {
    const {
      data: { list, pagination },
      handleChange,
    } = this.props;
    return (
      <Card title="收入详情表" bordered={false}>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={handleChange}
          rowKey="uuid"
        />
      </Card>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/analyze/notContract/TableDetail.js